import { useContext, useEffect, useState } from 'react'
import { NavigationContext } from '../NavigationContext'
import { debounce, filter, includes, map, toLower } from 'lodash'
import feathers from 'utility/client'
import { Business } from './Business'

export const DeviceStatistics = () => {
  const {setTitle} = useContext(NavigationContext)
  const [statistics, setStatistics] = useState({})
  const [businesses, setBusinesses] = useState([])
  const [business, setBusiness] = useState({ _id: '', name: ''})

  useEffect(() => {
    setBusinesses([])
  }, [business])

  useEffect(() => {
    setTitle('Dashboard')
    feathers.io.emit('statistic', 'statistic', {}, {}, (e, response) => {
      if (e) return
      setStatistics(response)
    })
  }, [])

  const handleSearch = debounce((event) => {
    const str = toLower(event.target.value)
    const searchable = statistics?.businesses || []

    if (!str) return searchable

    const result = filter(searchable, i =>
      includes(toLower(i.name || ''), str)
    )
    setBusinesses(result)
  }, 300)

  useEffect(() => {
    if (business._id) {
      const el = document.getElementById(`business-${business._id}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [business])

  return <div className="dashboard">
    <div className="row mb-4">
      {
        statistics?.distributors ? <div className="col-md-3">
          <div className="card">
            <div className="card-body">
              <p className="m-0">Distributors</p>
              <hr className="m-1"/>
              <h1 className="text-muted m-0">{ statistics?.distributors }</h1>
            </div>
          </div>
        </div> : null
      }

      {
        statistics?.resellers ? <div className="col-md-3">
          <div className="card">
            <div className="card-body">
              <p className="m-0">Resellers</p>
              <hr className="m-1"/>
              <h1 className="text-muted m-0">{ statistics?.resellers }</h1>
            </div>
          </div>
        </div> : null
      }

      {
        statistics?.totalBusinesses ? <div className="col-md-3">
          <div className="card">
            <div className="card-body">
              <p className="m-0">Businesses</p>
              <hr className="m-1"/>
              <h1 className="text-muted m-0">{ statistics?.totalBusinesses }<small className="h5">/ { statistics?.activeBusinesses || 0 } Active</small></h1>
            </div>
          </div>
        </div> : null
      }

      {
        statistics?.groups ? (
          <div className="col-md-3">
            <div className="card">
              <div className="card-body">
                <p className="m-0">Groups</p>
                <hr className="m-1"/>
                <h1 className="text-muted m-0"> {statistics?.groups} <small className="h5">/ { statistics?.activeGroups || 0 } Active</small></h1>
              </div>
            </div>
          </div>
        ) : null
      }

      {
        statistics?.totalDevices ? (
          <div className="col-md-3">
            <div className="card">
              <div className="card-body">
                <p className="m-0">Devices</p>
                <hr className="m-1"/>
                <h1 className="text-muted m-0"> {statistics.totalDevices}
                  <small className="h6 mx-1 p-1 border rounded">
                    { statistics?.activeRemoteDevices || 0 } <i className="fal fa-desktop"></i>
                  </small>
                  <small className="h6 mx-1 p-1 border rounded">
                    { statistics?.activeOfficeDevices || 0 } <i className="fal fa-mobile"></i>
                  </small>
                </h1>
              </div>
            </div>
          </div>
        ) : null
      }
    </div>

    <div className="d-flex">
      <div className="form-group business-search flex-grow-1">
        <div className="position-relative">
          <input type="text" onChange={handleSearch} placeholder="Type in the business name to see device statistics" className="form-control" />
          <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, display: 'flex', alignItems: 'center', padding: '0 1rem' }}>
            <i className="fal fa-search" style={{ fontSize: '1.5rem' }}></i>
          </div>
        </div>
        <div className="suggestions" style={{ display: businesses.length ? 'block' : 'none' }}>
          <div className="items">
            {
              map(businesses, b => (
                <div
                  onClick={() => setBusiness(b)}
                  key={b._id}
                  className="item"
                >
                  {business.name}
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>

    <div className="row g-1">
      {
        statistics?.businesses?.length ? statistics?.businesses?.map(b => (
          <div
            className={business._id === b._id ? 'col-12 p-1 py-4' : 'col-md-4 p-1'}
            id={`business-${b._id}`}
            key={b._id}
          >
            <Business
              active={business._id === b._id}
              business={b}
              onExpand={() => setBusiness(b)}
            />
          </div>
        )) : <div className="d-flex flex-column justify-content-center align-items-center opacity-25 my-4">
          <div>
            <i className="h1 fa fa-folder-open"></i>
          </div>
          <h4>No Businesses</h4>
        </div>
      }
    </div>
  </div>
}
